import { ReactNode } from "react";
import styles from "../aic.module.css";
import { MosaicTrafficLightClass } from "../traffic-lights/MosaicTrafficLightClass";
import { MosaicTrafficLightsValue } from "../traffic-lights/MosaicTrafficLightsValue";
import { useTableContext } from "./TableContextProvider";

interface AitColumnTrafficLightProps {
  cellid: string;
}

/**
 * Render traffic lights for a column identified by a cell id.
 *
 * @param props - Component props
 * @param props.cellid - The cell id used to find changed columns
 */
export const AitColumnTrafficLight = ({ cellid }: AitColumnTrafficLightProps): ReactNode => {
  const { state } = useTableContext();

  // Find all columns matching this cellid
  const matchingColumns =
    state?.processedTableData?.changedColumns?.filter(
      (dc) =>
        dc.idAfterTrafficLightIsShown === cellid ||
        (dc.idAfterTrafficLightIsShown === "" && cellid === "final"),
    ) ?? [];

  const tlValues: MosaicTrafficLightsValue[] =
    matchingColumns.length === 0
      ? ["BlankNotEvaluated"]
      : matchingColumns.map((col) => col.coreTrafficLight);

  const thisTrafficLight =
    !state?.noTrafficLights && tlValues.some((v) => v !== "BlankNotEvaluated" && v !== "none")
      ? new MosaicTrafficLightClass(tlValues, "-16px", "-8px").element
      : null;

  return !thisTrafficLight ? null : <div className={styles.absoluteLeft0}>{thisTrafficLight}</div>;
};

AitColumnTrafficLight.displayName = "AitColumnTrafficLight";
